import { FC } from 'react';
import InputWithSuffix from '../InputWithSuffix';
import { Image, InputProps } from '@qga/roo-ui/components';
import { qantasBusinessRewards } from '@qga/roo-ui/logos';

type Props = InputProps;

const QbrInput: FC<Props> = (props) => (
  <InputWithSuffix {...props}>
    <Image src={qantasBusinessRewards} alt="Qantas Business Rewards Logo" />
  </InputWithSuffix>
);

export default QbrInput;
